import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/finance.css';
import './components/Sidebar.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './Context/AuthContext';
import { PrivyProvider } from '@privy-io/react-auth';
import { base, bsc } from 'viem/chains';
import PrivySessionBridge from './components/PrivySessionBridge';

// Identidad por wallet (SIWE). Privy provee la wallet (embebida AA + externa);
// la sesión la emite NUESTRO backend (routes/wallet.js). Si no hay App ID
// configurado, la app sigue funcionando con email/password — el botón de wallet
// no se monta (lo decide AuthModal).
const PRIVY_APP_ID = process.env.REACT_APP_PRIVY_APP_ID;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {PRIVY_APP_ID ? (
      <PrivyProvider
        appId={PRIVY_APP_ID}
        config={{
          // Activación inicial mínima: email (crea wallet embebida sin semillas) +
          // wallet externa. Después se pueden sumar 'google' y 'passkey' en el
          // dashboard de Privy sin tocar código (agregándolos a esta lista).
          loginMethods: ['email', 'wallet'],
          embeddedWallets: { createOnLogin: 'users-without-wallets' },
          defaultChain: base,
          supportedChains: [base, bsc],   // Base (escrow futuro) + BNB Chain (pagos de fee)
          appearance: {
            theme: 'dark',
            accentColor: '#00d412',          // verde de marca
            logo: '/assets/Logo-White.png',
            walletChainType: 'ethereum-only',
          },
        }}
      >
        <AuthProvider>
          <PrivySessionBridge />
          <App />
        </AuthProvider>
      </PrivyProvider>
    ) : (
      <AuthProvider>
        <App />
      </AuthProvider>
    )}
  </React.StrictMode>
);

reportWebVitals();
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
